/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { Alert, Button, Grid, Snackbar, Typography } from '@mui/material';
import MainCard from '../../ui-component/cards/MainCard';
import SecondaryAction from '../../ui-component/cards/CardSecondaryAction';
import { gridSpacing } from '../../store/constant';
import { Label } from 'reactstrap';
import axiosInstance from '../../axiosInstance';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import configData from '../../config';

const ManageUsers = () => {
    const [roles, setRoles] = useState([]);
    const [licenseInfo, setLicenseInfo] = useState({
        total_licenses: 0,
        licenses_used: 0,
        licenses_available: 0,
    });
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

    const role = useSelector((state) => state.account.role);
    const org_id = useSelector((state) =>
        state?.account?.org?.id ? state?.account?.org?.id : state?.account?.org_data?.data?.id
    );

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        defaultValues: {
            memberName: '',
            phone: '',
            email: '',
            password: '',
            role: '',
        },
    });

    // Fetch license info
    useEffect(() => {
        const fetchLicenseInfo = async () => {
            try {
                const res = await axiosInstance.get(`${configData.API_SERVER}/organization/get_license_info/${org_id}`);
                setLicenseInfo(res.data);
            } catch (error) {
                console.error('Error fetching license info:', error);
            }
        };

        if (org_id) {
            fetchLicenseInfo();
        }
    }, [org_id]);

    // Fetch roles
    useEffect(() => {
        const fetchRoleData = async () => {
            try {
                const res = await axiosInstance.get(`${configData.API_SERVER}/user/get_roles`);
                if (role === 'Super Admin') {
                    setRoles(res.data.filter((item) => item.role !== 'Super Admin' && item.role !== 'Owner'));
                } else if (role === 'Admin') {
                    setRoles(res.data.filter((item) => item.role !== 'Super Admin' && item.role !== 'Owner'));
                } else if (role === 'Department Head') {
                    setRoles(
                        res.data.filter(
                            (item) =>
                                item.role !== 'Super Admin' &&
                                item.role !== 'Admin' &&
                                item.role !== 'Department Head' &&
                                item.role !== 'Owner'
                        )
                    );
                }
            } catch (error) {
                console.error('Error fetching roles:', error);
            }
        };

        if (['Super Admin', 'Admin', 'Department Head'].includes(role)) {
            fetchRoleData();
        }
    }, [role]);

    const showMessage = (message, severity = 'success') => {
        setSnackbar({ open: true, message, severity });
    };

    const memberSubmit = async (data) => {
        if (licenseInfo.licenses_available <= 0) {
            showMessage('You have exhausted all your licenses. Please assign more licenses to create new users.', 'error');
            return;
        }

        try {
            data.org_id = org_id; // Add org_id to the request
            const res = await axiosInstance.post(`${configData.API_SERVER}/organization/update_member/`, data);
            showMessage(res.data?.message || 'Update member submitted successfully.', 'success');

            // Refresh license info after user creation
            const updatedLicenseInfo = await axiosInstance.get(`${configData.API_SERVER}/organization/license_info/${org_id}`);
            setLicenseInfo(updatedLicenseInfo.data);
        } catch (error) {
            if (error.response) {
                if (error.response.data?.message || error.response.data?.msg || error.response.data?.error) {
                    showMessage(error.response.data.message || error.response.data.msg || error.response.data.error, 'error');
                } else {
                    showMessage('Unable to submit member update.', 'error');
                }
            } else if (error.request) {
                showMessage('Server did not respond. Please try again.', 'error');
            } else {
                showMessage(error.message || 'Unable to submit member update.', 'error');
            }
        }
    };

    return (
        <React.Fragment>
            <MainCard title="Manage Users" secondary={<SecondaryAction />}>
                <Typography variant="subtitle1">User Creation</Typography>

                {/* Display License Info */}
                <Grid container spacing={gridSpacing}>
                    <Grid item lg={4} md={6} sm={12} xs={12}>
                        <Typography variant="body2">Total Licenses: {licenseInfo.total_licenses}</Typography>
                        <Typography variant="body2">Licenses Used: {licenseInfo.licenses_used}</Typography>
                        <Typography variant="body2">Licenses Available: {licenseInfo.licenses_available}</Typography>
                    </Grid>
                </Grid>

                {/* User Form */}
                <form onSubmit={handleSubmit(memberSubmit)}>
                    <Grid container spacing={gridSpacing}>
                        {/* User Name Input */}
                        <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid1">
                            <Grid lg={2} md={6} sm={12} xs={12} className="sad_Single">
                                <Label style={{ fontSize: '14px !important' }}>
                                    User Name<span style={{ color: 'red' }}>*</span>
                                </Label>
                            </Grid>
                            <Grid lg={4} md={12} sm={12} xs={12} className="sad_Single">
                                <input
                                    className="form-control"
                                    placeholder="Enter user name"
                                    {...register('memberName', {
                                        required: 'User Name is required',
                                        pattern: /^[A-Za-z\s]+$/i,
                                    })}
                                />
                                {errors.memberName && (
                                    <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-1px' }}>
                                        {errors.memberName.message}
                                    </p>
                                )}
                            </Grid>
                        </Grid>

                        {/* User Login Details */}
                        <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid1">
                            <Grid lg={2} md={6} sm={12} xs={12} className="sad_Single">
                                <Label style={{ fontSize: '14px !important' }}>
                                    User Login Details<span style={{ color: 'red' }}>*</span>
                                </Label>
                            </Grid>
                            <Grid lg={4} md={12} sm={12} xs={12} className="sad_Single">
                                <input
                                    className="form-control"
                                    placeholder="Enter Email-id"
                                    {...register('email', {
                                        required: 'Email is required',
                                        pattern: {
                                            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                            message: 'Invalid email address',
                                        },
                                    })}
                                />
                                {errors.email && (
                                    <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-10px' }}>
                                        {errors.email.message}
                                    </p>
                                )}
                                <input
                                    type="password"
                                    className="form-control"
                                    placeholder="Password for user login"
                                    {...register('password', { required: 'Password is required' })}
                                    autoComplete="new-password"
                                />
                                {errors.password && (
                                    <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-10px' }}>
                                        {errors.password.message}
                                    </p>
                                )}
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Phone"
                                    {...register('phone', {
                                        required: 'Phone number is required',
                                        pattern: {
                                            value: /^[0-9]+$/,
                                            message: 'Phone number must be numeric',
                                        },
                                    })}
                                />
                                {errors.phone && (
                                    <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-1px' }}>
                                        {errors.phone.message}
                                    </p>
                                )}
                            </Grid>
                        </Grid>

                        {/* User Role Selection */}
                        <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid1">
                            <Grid lg={2} md={6} sm={12} xs={12} className="sad_Single">
                                <Label style={{ fontSize: '14px !important' }}>
                                    User Role<span style={{ color: 'red' }}>*</span>
                                </Label>
                            </Grid>
                            <Grid lg={4} md={12} sm={12} xs={12} className="sad_Single">
                                <select
                                    className="form-control"
                                    {...register('role', { required: 'Role selection is required' })}
                                >
                                    <option value="">Select Role</option>
                                    {roles.map((item, index) => (
                                        <option key={index} value={item.role}>
                                            {item.role}
                                        </option>
                                    ))}
                                </select>
                                {errors.role && (
                                    <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-10px' }}>
                                        {errors.role.message}
                                    </p>
                                )}
                            </Grid>
                        </Grid>

                        {/* Save Button */}
                        <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid" style={{ marginTop: '-2rem' }}>
                            <Grid lg={4} sm={6}>
                                <Button type="submit" variant="outlined" style={{ marginLeft: '15px', marginTop: '10px' }}>
                                    Save Details
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
            </MainCard>
            <Snackbar
                open={snackbar.open}
                autoHideDuration={3500}
                onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert
                    severity={snackbar.severity}
                    onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
                    sx={{ width: '100%' }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </React.Fragment>
    );
};

export default ManageUsers;
